import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import { Cancel, CheckCircle } from '@material-ui/icons';
import { PropTypes } from 'prop-types';
import { getRTLPopperStyles } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    columnGap: theme.spacing(0.5),
    alignItems: 'center'
  },
  suggestionButton: {
    padding: 0
  },
  checkCircle: {
    fill: theme.palette.success.main
  },
  cancelCircle: {
    fill: theme.palette.error.main
  }
}));

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    maxWidth: 'fit-content'
  })
}));

export const DelaRecommendationButtons = ({
  classes: classesOverride,
  onAccept,
  onReject
}) => {
  const intl = useIntl();
  const classes = useStyles({ classes: classesOverride });
  const tooltipPopperClasses = useTooltipPopperStyles();

  const acceptTooltipTitle = intl.formatMessage({
    id: 'dela.acceptSuggestion'
  });
  const rejectTooltipTitle = intl.formatMessage({
    id: 'dela.rejectSuggestion'
  });

  return (
    <div className={classes.root}>
      <Tooltip
        title={acceptTooltipTitle}
        aria-label={acceptTooltipTitle}
        placement="bottom-start"
        classes={tooltipPopperClasses}
      >
        <IconButton
          className={classes.suggestionButton}
          onClick={onAccept}
          aria-label={acceptTooltipTitle}
        >
          <CheckCircle className={classes.checkCircle} />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={rejectTooltipTitle}
        aria-label={rejectTooltipTitle}
        placement="bottom-start"
        classes={tooltipPopperClasses}
      >
        <IconButton
          className={classes.suggestionButton}
          onClick={onReject}
          aria-label={rejectTooltipTitle}
        >
          <Cancel className={classes.cancelCircle} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

DelaRecommendationButtons.propTypes = {
  classes: PropTypes.object,
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};

export default DelaRecommendationButtons;
